export enum BrandEnum {
  GRAWE = 'grawe',
  WIENER = 'wiener',
  UNIQA = 'uniqa',
  ALLIANZ = 'allianz'
}